import { action } from 'mobx';
import { api } from 'shared/api/api';
import { EntityStore } from 'shared/stores/EntityStore';

class ApplicantHistoryStore extends EntityStore {
	entityPluralEndpoint = 'applicants/history';
	constructor() {
		super('applicant-history');
	}

	@action
	async updateHistory(applicantId, historyId, history) {
		const result = await api.put(
			`applicants/${applicantId}/history/${historyId}`,
			history
		);
		return result;
	}
}

export const applicantHistoryStore = new ApplicantHistoryStore();
